import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BtnDeleteRowRendererComponent } from './btn-delete-row-renderer.component';
import { GridApiRegistry } from './grid-api-registry';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit, OnDestroy {
  @Input() component: any;
  @Input() formDesign: any;
  gridColumnApi: any;  
  gridApi: any;
  gridOptions: any = {
    defaultColDef: {
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- & HERE
      minWidth: 225,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    // headerHeight: 150,
    popupParent: document.querySelector('body'),
    // floatingFilter: true,
  };
  constructor() {}

  ngOnInit(): void {
    // Initialize rowData if not present
    if (!this.component.element.rowData) {
      this.component.element.rowData = [];
    }

    // Setup framework components for custom renderers
    if (!this.component.element.frameworkComponents) {
      this.component.element.frameworkComponents = {};
    }
    this.component.element.frameworkComponents['btnDeleteRowRenderer'] = BtnDeleteRowRendererComponent;

    // Add delete column if showDeleteButton is enabled
    if (this.component.element.showDeleteButton) {
      this.addDeleteColumn();
    }
  }

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (this.component?.id) {
    GridApiRegistry.set(this.component.id, this.gridApi); // ← store in registry instead
  }
  }

  addDeleteColumn(): void {
    if (!this.component.element.columnDefs) {
      this.component.element.columnDefs = [];
    }

    // Check if delete column already exists
    const deleteColumnExists = this.component.element.columnDefs.some(
      (col: any) => col.field === '__delete'
    );

    if (!deleteColumnExists) {
      this.component.element.columnDefs.push({
        headerName: 'Delete',
        field: '__delete',
        width: 100,
        cellRenderer: 'btnDeleteRowRenderer',
        cellRendererParams: {
          onClick: this.onDeleteRow.bind(this)
        },
        editable: false,
        sortable: false,
        filter: false,
        resizable: false
      });
    }
  }

  onDeleteRow(params: any): void {
    this.deleteRow(params.rowIndex);
  }

  addRow(): void {
    const newRow: any = {};
    // Initialize empty values for each column
    if (this.component?.element?.columnDefs) {
      this.component.element.columnDefs.forEach((col: any) => {
        newRow[col.field] = '';
      });
    }
    
    if (!this.component.element.rowData) {
      this.component.element.rowData = [];
    }
    
    this.component.element.rowData.push(newRow);
    
    // Refresh grid
    if (this.gridApi) {
      this.gridApi.setRowData(this.component.element.rowData);
    }
  }

  deleteRow(rowIndex: number): void {
    if (this.component.element.rowData && rowIndex >= 0) {
      this.component.element.rowData.splice(rowIndex, 1);
      
      // Refresh grid
      if (this.gridApi) {
        this.gridApi.setRowData(this.component.element.rowData);
      }
    }
  }
  ngOnDestroy(): void {
  if (this.component?.id) {
    GridApiRegistry.delete(this.component.id);
  }
}
}
